<template>
<div v-if="value">
    <div class="loading">
        <div>
            <i class="el-icon-loading"></i><span>
            <slot></slot>
        </span>
        </div>

    </div>
    <div class="estop">
    </div>
</div>
</template>

<script>
export default {
    props: ["value"]
}
</script>

<style lang="scss" scoped>
.estop {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 998;
}

.loading {
    position: fixed;
    z-index: 9999;
    top: 0;
    box-sizing: border-box;
    padding: 30px 50px;
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 14px;
    color: #fff;
    max-width: 410px;
    height: 80px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;

    span {
        line-height: 21px;
    }

    >div {
        display: flex;
        justify-content: center
    }

    i {
        margin-right: 8px;
        font-size: 20px;
    }
}
</style>
